<template>
  <div class="search-slide-filter">
    <div class="relative w-60" v-click-outside="closeFilter">
      <div class="type-selected" @click="openFilter" :class="{active: isShowFilter}">
        {{ selectedType.name }}
        <span></span>
        <i class="fas fa-sort-down" v-if="isShowFilter"></i>
        <i class="fas fa-sort-up" v-else></i>
      </div>
      <div class="filter-list" v-if="isShowFilter">
        <div v-for="(item, index) in allTypeSlides" :key="index" class="mb-2">
          <aha-checkbox
            :id="`filter-type-${index}`"
            v-model="item.selected"
            @change="handleSelectType(item)"
          >
            <span v-if="item.name !== 'Pick Answer'">
              {{ item.name }}
            </span>
            <span v-else>
              Quiz
            </span>
          </aha-checkbox>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Constant from '@/constant'

const ALL_SLIDE_TYPES = 'All slide types'

export default {
  components: {
  },
  props: {
    selectedType: {
      type: Object,
      default: () => {
        return {
          name: ALL_SLIDE_TYPES,
          filter: [],
        }
      },
    },
  },
  data() {
    return {
      allTypeSlides: [],
      isShowFilter: false,
    }
  },
  created() {
    const types = [
      {
        type: 'all',
        name: ALL_SLIDE_TYPES,
        selected: true,
      },
    ]
    Constant.allTypeSections.forEach((item) => {
      item.slideTypes.forEach((typeData) => {
        const index = types.findIndex((data) => {
          return data.type === typeData.type
        })
        if (index === -1 && typeData.type !== 'leaderboard' && typeData.type !== 'qrcode' && typeData.type !== 'multipleChoice') {
          types.push(typeData)
        }
      })
    })

    this.allTypeSlides = types.map((item) => {
      item.selected = true
      return item
    })
  },
  methods: {
    openFilter() {
      this.isShowFilter = !this.isShowFilter
      this.$emit('open')
    },

    closeFilter() {
      this.isShowFilter = false
      this.$emit('close')
    },

    handleSelectType(item) {
      if (item.type !== 'all') {
        this.allTypeSlides[0].selected = false
      } else {
        this.allTypeSlides = this.allTypeSlides.map((slideType) => {
          if (slideType.type !== 'all') {
            slideType.selected = item.selected
          }
          return slideType
        })
      }
      let selectedType = {
        name: ALL_SLIDE_TYPES,
        filter: [],
      }
      if (this.allTypeSlides[0].selected) {
        selectedType = {
          name: ALL_SLIDE_TYPES,
          filter: [],
        }
      } else {
        const filters = this.allTypeSlides.filter((slideType) => slideType.selected)
        if (!filters.length) {
          selectedType = {
            name: 'No filter selected',
            filter: [],
          }
        } else {
          selectedType.name = `${filters.length} slide types`
          selectedType.filter = filters
        }
      }
      this.$emit('changeFilter', selectedType)
    },
  },
}
</script>

<style lang="scss" scoped>
.search-slide-filter {
  z-index: 10;
  position: relative;
}
.filter-list {
  @apply appearance-none absolute shadow rounded cursor-pointer;
  @apply p-4 w-full text-base border border-secondary-20 font-bold;
  background-color: #fff;
}
.type-selected {
  @apply appearance-none relative w-full mb-2;
  @apply w-full text-base border border-secondary-20;
  background-color: #fff;
  box-shadow: 0px 1px 3px rgba(211, 215, 225, 0.81);
  border-radius: 4px;
  padding: 8px 12px;

  &.active {
    @apply border-primary-90;
  }

  i {
    @apply absolute;
    top: 15px;
    right: 16px;

    &.fa-sort-down {
      top: 9px;
    }
  }

  span {
    position: absolute;
    top: 7px;
    right: 39px;
    width: 1px;
    background-color: #d3d7e1;
    display: block;
    height: 25px;
  }
}
</style>
